import { getConfig } from './actions';

export const apiClient = {
  getConfig,
};
